import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter } from 'rxjs';

import { AuthService } from './core/services/auth.service';
import { FooterComponent } from "./shared/components/footer/footer.component";
import { SpinnerComponent } from "./shared/components/spinner/spinner.component";

@UntilDestroy()
@Component({
    selector: 'app-root',
    standalone: true,
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    imports: [RouterOutlet, SpinnerComponent]
})
export class AppComponent {
  title = 'sequenza';

  currentUser$ = this.authService.currentUser$;

  constructor(
    translateService: TranslateService,
    private authService: AuthService,
  ) {
    translateService.addLangs(['en', 'de', 'fr', 'nl']);
    translateService.setDefaultLang('en');

    const browserLang = translateService.getBrowserLang();
    translateService.use(browserLang.match(/en|de|fr|nl/) ? browserLang : 'en');

    this.currentUser$.pipe(
      filter(user => !!user),
      untilDestroyed(this)
    ).subscribe(user => {
      translateService.use(user.lang);
    });
  }
}
